import { get, put } from '.';

export function GetRegions(options = {}) {
	return get<any>("/app/api/regions", options);
}

export function UpdateRegion(regionId: number, options = {}) {
	return put<any>(`/app/api/regions/${regionId}`, options);
}